export default __webpack_public_path__ + "static/adorno12-8e9d596401e997dae9b301a0fae2b7c1.png";